import { createSelector } from '@reduxjs/toolkit';
import { selectFx } from '../../store/selectors';

export const selectListState = createSelector(selectFx, (forexRateState) => forexRateState.list);
export const selectParameters = createSelector(selectListState, (listState) => listState.parameters);
export const selectForexCurrencyPairList = createSelector(selectListState, (listState) => listState?.forexCurrencyPairList);
